export const partners = [
  {
    name: "Fuji Electric",
    rank: 1,
    image: "fuji-electric.svg",
  },
  {
    name: 'Fujitsu',
    rank: 2,
    image: 'fujitsu.svg'
  },
  {
    name: "Fujitsu General",
    rank: 3,
    image: "general.svg",
  },
  {
    name: "Daikin",
    rank: 4,
    image: "daikin.svg",
  },
  {
    name: "Mitsubishi Electric",
    rank: 5,
    image: "mitsubishi_electric.svg",
  },
  {
    name: "Mitsubishi Heavy",
    rank: 6,
    image: "mitsubishi-heavy.svg",
  },
  {
    name: "Gree",
    rank: 7,
    image: "gree-electric.svg",
  },
  {
    name: "Vivax",
    rank: 8,
    image: "vivax.svg",
  },
  {
    name: "LG",
    rank: 9,
    image: "lg.svg",
  },
  {
    name: "Hitachi",
    rank: 10,
    image: "hitachi.svg",
  },
  {
    name: "Toshiba",
    rank: 11,
    image: "toshiba.svg",
  },
  {
    name: "Midea",
    rank: 12,
    image: "midea.svg",
  },
  {
    name: "Panasonic",
    rank: 13,
    image: "panasonic.svg",
  },
  {
    name: "National",
    rank: 14,
    image: "national.svg",
  },
];
